import styled from 'styled-components';

export default styled.div`
  && {
    .※ {
      color: rgba(255, 0, 0, 1);
      height: 18px;
      width: 12px;
      margin-right: 4px;
    }
    .rental-detail {
      background-color: #eeeeee;
      min-height: 360px;
      .input-rental-detail {
        padding-left: 86px;
        padding-top: 44px;
        padding-bottom: 44px;
        .checked-box {
          margin-bottom: 16px;
        }
        .title-check-box {
          font-weight: 600;
          margin-left: 8px;
        }
        .dflex {
          display: flex;
        }
        .dflex-col {
          display: flex;
          align-items: center;
        }
        .ant-form-item {
          margin-bottom: 0px;
        }
        .input-width-date {
          width: 171px;
          height: 40px;
        }
        .input-width-select {
          width: 335px;
          height: 40px;
        }
        .input-width {
          width: 303px;
          height: 40px;
        }
        .baseline {
          align-items: baseline;
        }
        .mg-10 {
          margin-left: 10px;
          margin-right: 10px;
        }
        .mt-20 {
          margin-top: 20px;
        }
        .ml-10 {
          margin-left: 10px;
        }
        .mt-10 {
          margin-top: 10px;
        }
      }
    }
    .table-add-detail {
      margin-top: 65px;
    }
    .btn-confirm-register {
      width: 240px;
      height: 60px;
      background-color: #ff8a00;
      color: white;
      text-align: center;
      box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      border: none;
      margin: 0px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
    }
  }
`;
